import { z } from 'zod';

import { UnidentifiedSchema } from './sbc-customer';

export const ShippingAddressSchema = z.object({
  line1: z.string().nullable(),
  line2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postalCode: z.string().nullable(),
  country: z.string().nullable(),
});
export type ShippingAddress = z.infer<typeof ShippingAddressSchema>;

export const AddressIssueSchema = z.object({
  code: z.string().nullable(),
  field: z.string().nullable(),
  message: z.string(),
});
export type AddressIssue = z.infer<typeof AddressIssueSchema>;

export const AddressVerificationSchema = z.object({
  deliverable: z.boolean(),
  suggestedAddress: ShippingAddressSchema.nullable(),
  reasons: z.array(AddressIssueSchema),
});
export type AddressVerification = z.infer<typeof AddressVerificationSchema>;

export const ADDRESS_USES = ['account', 'unshipped-order'] as const;
export type AddressUse = (typeof ADDRESS_USES)[number];

const CheckedAddressSchema = z.object({
  usedFor: z.array(z.enum(ADDRESS_USES)).min(1),
  orderNumber: z.string().nullable(),
  address: ShippingAddressSchema,
});

export const AddressCheckSchema = z.discriminatedUnion('status', [
  CheckedAddressSchema.extend({ status: z.literal('checked') }).extend(
    AddressVerificationSchema.shape,
  ),
  CheckedAddressSchema.extend({ status: z.literal('not-checked'), reason: z.string() }),
  CheckedAddressSchema.extend({ status: z.literal('unavailable') }),
]);
export type AddressCheck = z.infer<typeof AddressCheckSchema>;

export const AddressCheckResultSchema = z.union([
  z.object({
    identified: z.literal(true),
    available: z.literal(true),
    addresses: z.array(AddressCheckSchema),
  }),
  z.object({
    identified: z.literal(true),
    available: z.literal(false),
    reason: z.string(),
  }),
  UnidentifiedSchema,
]);
export type AddressCheckResult = z.infer<typeof AddressCheckResultSchema>;
